import React from 'react';
import { PipelineStageData, PipelineCard } from '../../types/pipeline';
import PipelineCardComponent from './PipelineCard';

interface PipelineStageProps {
  stage: PipelineStageData;
  onCardClick: (card: PipelineCard) => void;
  onCardMove: (cardId: string, fromStage: string, toStage: string) => void;
}

const PipelineStage: React.FC<PipelineStageProps> = ({
  stage,
  onCardClick,
  onCardMove
}) => {
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.currentTarget.classList.add('bg-gray-100', 'dark:bg-gray-700');
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.currentTarget.classList.remove('bg-gray-100', 'dark:bg-gray-700');
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.currentTarget.classList.remove('bg-gray-100', 'dark:bg-gray-700');
    
    const cardId = e.dataTransfer.getData('cardId');
    const fromStage = e.dataTransfer.getData('fromStage');
    
    if (cardId && fromStage !== stage.stage) {
      onCardMove(cardId, fromStage, stage.stage);
    }
  };

  return (
    <div 
      className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 flex flex-col h-full"
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {/* Stage Header */}
      <div 
        className="p-4 border-b border-gray-200 dark:border-gray-700"
        style={{ borderTopColor: stage.color, borderTopWidth: '4px' }}
      >
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{stage.title}</h3>
          <span className="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 px-2 py-1 rounded-full text-sm font-medium">
            {stage.count}
          </span>
        </div>
        <div className="text-sm text-gray-600 dark:text-gray-400">
          {stage.totalValue.toLocaleString('hu-HU')} HUF
        </div>
      </div>

      {/* Cards Container */}
      <div className="flex-1 p-4 space-y-3 overflow-y-auto max-h-[calc(100vh-300px)]">
        {stage.cards.length === 0 ? (
          <div className="text-center py-8 text-gray-400 dark:text-gray-500 text-sm">
            Nincs elem
          </div>
        ) : (
          stage.cards.map(card => (
            <PipelineCardComponent
              key={card.id}
              card={card}
              onClick={() => onCardClick(card)}
              stageColor={stage.color}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default PipelineStage;
